import FeatureContainer from "../../../Layout/Containers/FeatureContainer";
import { Link, useLocation } from "react-router-dom";
import { Button } from "reactstrap";

const DaftarAbsen = ({ selectedComponent, children, toggle, isPNS }) => {
  const location = useLocation();
  const { search, pathname } = location;
  const parameters = new URLSearchParams(search);
  const type = parameters.get("type");

  return (
    <FeatureContainer
      title={
        type === "tahunan"
          ? "Rekap Absen Tahunan"
          : type === "bulanan"
          ? "Rekap Absen Bulanan"
          : "List Absen"
      }
      subtitle={
        type === "tahunan"
          ? "Rekap Absen Tahunan"
          : type === "bulanan"
          ? "Rekap Absen Bulanan"
          : "List Absen"
      }
    >
      <div className="d-flex justify-content-center">
        <AbsenNavBar
          activeComponent={selectedComponent}
          toggle={toggle}
          isOpen={isPNS}
          type={type}
        />
      </div>
      {children}
    </FeatureContainer>
  );
};

const AbsenNavBar = ({ activeComponent, toggle, isOpen, type }) => {
  return (
    <div className="d-flex gap-1 mb-5">
      <div>
        {
          !type ? (
            <Button onClick={toggle} active={activeComponent === null}>
              Lihat {isOpen ? "Staf" : "PNS"} Tanggal Ini
            </Button>
          ) : (
            <Link to={`${process.env.PUBLIC_URL}/absen`}>
              <Button active={activeComponent === null}>
                Lihat {isOpen ? "Staf" : "PNS"} Tanggal Ini
              </Button>
            </Link>
          )
        }
      </div>
      <div>
        <Link to={`${process.env.PUBLIC_URL}/absen?type=bulanan`} active={activeComponent === "bulanan"}>
          <Button active={activeComponent === 'bulanan'}>Lihat Rekap Absen Bulanan</Button>
        </Link>
      </div>
      <div>
        <Link to={`${process.env.PUBLIC_URL}/absen?type=tahunan`} active={activeComponent === "tahunan"}>
          <Button active={activeComponent === 'tahunan'}>Lihat Rekap Absen Tahunan</Button>
        </Link>
      </div>
    </div>
  );
};

export default DaftarAbsen;
